export class ChangeDecisionModel {
  decisionId = 1;
  reason = 1;
  details = "";
  challengeOption = 1;
  infoDetails = "";
  cancelOption = 2;
}
